import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import { MyAllElemCollegioSindacaleEntity } from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSpaOrdinarioControl,
    getAmmControlloControl,
    normeSpaOrdinarioCkHelper,
    normeSpaOrdinarioRequiredHelper,
    checkCkNormeValue,
} from './helpers/norme-spa-ordinario-form-validators.helper';

export const normeSpaOrdinarioAssembleaRules: FormGroupRules = {
    my_CkSpoGratuitaCariche: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_CkSpoGratuitaCariche');
    },

    my_CkSpoAssembAppBil: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_CkSpoAssembAppBil');
    },

    my_CkSpoAssembNominAmmin: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_CkSpoAssembNominAmmin');
    },

    my_CkSpoAssembNominOrgano: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_CkSpoAssembNominOrgano');
    },

    my_CkSpoAssembNominSind: (form: FormGroup) => {
        const my_CkSpoAssembNominSindControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoAssembNominSind');
        const my_CkSpoAssembNominSind: string = my_CkSpoAssembNominSindControl.value;
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(
            form,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const errors = my_CkSpoAssembNominSindControl.errors ? my_CkSpoAssembNominSindControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && my_CkSpoAssembNominSind === '1' && !my_AllElemCollegioSindacale?.length, errors, 'my_CkSpoAssembNominSind', {
            status: "Inserire l'organo di controllo",
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoAssembNominSind === '0' && !!my_AllElemCollegioSindacale?.length, errors, 'my_CkSpoAssembNominSind', {
            status: 'Eliminare il Collegio Sindacale',
            message: 'In caso di risposta negativa occorre eliminare tutti i membri del Collegio Sindacale',
        });

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoAssembNominSind), errors, 'my_CkSpoAssembNominSind', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoAssembNominSindControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoAssembDetCompAmmin: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoAssembDetCompAmmin', 'my_NormeSpaOrdinario.my_CkSpoGratuitaCariche', 0);
    },

    my_CkSpoAssembDetCompSindaci: (form: FormGroup) => {
        const my_CkSpoAssembNominSind: string = getNormeSpaOrdinarioControl(form, 'my_CkSpoAssembNominSind').value;
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_CkSpoAssembDetCompSindaci',
            'my_NormeSpaOrdinario.my_CkSpoGratuitaCariche',
            0,
            formPaths.ammControllo,
            my_CkSpoAssembNominSind === '1'
        );
    },

    my_SpoNoteFunzAssemb: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_SpoNoteFunzAssemb');
    },

    my_CkSindaciRiunioniLiquidatori: (form: FormGroup) => {
        const my_CkSindaciRiunioniLiquidatoriControl = getAmmControlloControl(form, 'my_CkSindaciRiunioniLiquidatori');
        const my_AllElemLiquidatori: string = getAmmControlloControl(form, 'my_AllLiquidatori.my_AllElemLiquidatori').value;
        const my_CkSpoAssembNominSind: string = getNormeSpaOrdinarioControl(form, 'my_CkSpoAssembNominSind').value;
        const errors = my_CkSindaciRiunioniLiquidatoriControl.errors ? my_CkSindaciRiunioniLiquidatoriControl.errors : {};

        addRemoveError(
            isNilOrEmpty(my_CkSindaciRiunioniLiquidatoriControl?.value) && my_CkSpoAssembNominSind === '1' && !!my_AllElemLiquidatori?.length,
            errors,
            'my_CkSindaciRiunioniLiquidatori',
            { status: REQUIRED_STATUS }
        );

        my_CkSindaciRiunioniLiquidatoriControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
